import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
})
export class ConfirmationDialogComponent {
  @Input()
  title: string = "Richiesta conferma";

  @Input()
  message: string = "Sei sicuro di voler procedere?";

  @Input()
  confirmButtonLabel: string = "Conferma";

  @Input()
  cancelButtonLabel: string = "Annulla";

  constructor(private activeModal: NgbActiveModal) {}

  onClickCancel(): void {
    this.activeModal.close(false);
  }

  onClickConfirm(): void {
    this.activeModal.close(true);
  }
}
